import * as React from "react";

export function PsycheRadarLabelLayer({ controller }: { controller: any }) {
    const spokeRenderData: any[] = controller.spokeRenderData;

    return (
        <>
            {spokeRenderData.map((item: any) => {
                const { spoke, index, isActive, spokeOpacity, isInteractable, labelLayout, spokeVisibility, labelColor, hasAsteriskPrefix, hasPlusPrefix, hasMinusPrefix, isLabelBeyondOuterRadius, isLabelDragging, noteTooltipLayout } = item;
                const isLocked = controller.isTouchZoomLocked;
                const canInteract = isInteractable && !isLocked;

                return (
                <g key={`${spoke.id}-label`} opacity={(isActive ? spokeVisibility : spokeVisibility * 0.95) * spokeOpacity}>
                    <rect x={labelLayout.x} y={labelLayout.y} width={labelLayout.width} height={labelLayout.height} rx="6" fill="#0c0a09" stroke={hasAsteriskPrefix ? "#ffffff" : hasPlusPrefix ? "#53f29a" : hasMinusPrefix ? "#ff6f6f" : "#1b1715"} strokeWidth="1" pointerEvents="none" />
                    <rect
                        x={labelLayout.x}
                        y={labelLayout.y}
                        width={labelLayout.width}
                        height={labelLayout.height}
                        rx="6"
                        fill="transparent"
                        stroke="transparent"
                        strokeWidth="14"
                        data-radar-interactive="true"
                        pointerEvents={canInteract ? "all" : "none"}
                        style={{ cursor: canInteract ? (isLabelDragging ? "grabbing" : "grab") : "default" }}
                        onPointerEnter={() => {
                            if (!canInteract) return;
                            controller.setHoveredIndex(index);
                            controller.setNoteTooltipIndex(spoke.notes.trim() ? index : null);
                        }}
                        onPointerLeave={() => {
                            if (!canInteract) return;
                            controller.setHoveredIndex(null);
                            controller.setNoteTooltipIndex(null);
                        }}
                        onPointerDown={(event) => {
                            if (!canInteract) return;
                            event.preventDefault();
                            event.stopPropagation();
                            controller.setSelectedIndex(index);
                            controller.setLabelDraggingIndex(index);
                        }}
                    />
                    {spoke.notes.trim() ? <circle cx={labelLayout.x + labelLayout.width - 7} cy={labelLayout.y + 7} r="2.25" fill="#f5d28f" opacity="0.22" pointerEvents="none" /> : null}
                    <text fill={labelColor} fontSize={labelLayout.fontSize} fontFamily="inherit" textAnchor="middle" opacity={isActive ? "1" : "0.95"} fontWeight={isActive ? 700 : 400} pointerEvents="none">
                        {labelLayout.lines.map((line: string, lineIndex: number) => (
                            <tspan key={`${spoke.id}-line-${lineIndex}`} x={labelLayout.textX} y={labelLayout.lineCenterYs[lineIndex]} dominantBaseline="middle">
                                {line}
                            </tspan>
                        ))}
                    </text>
                    {isLabelDragging && isLabelBeyondOuterRadius ? <line x1={labelLayout.x + 6} y1={labelLayout.y + labelLayout.height / 2} x2={labelLayout.x + labelLayout.width - 6} y2={labelLayout.y + labelLayout.height / 2} stroke="#f5d28f" strokeWidth="2.5" strokeLinecap="round" opacity="0.9" pointerEvents="none" /> : null}
                    {controller.noteTooltipIndex === index && noteTooltipLayout ? (
                        <g pointerEvents="none">
                            <rect x={noteTooltipLayout.x} y={noteTooltipLayout.y} width={noteTooltipLayout.width} height={noteTooltipLayout.height} rx="6" fill="rgba(8, 7, 6, 0.92)" stroke="rgba(245, 210, 143, 0.5)" strokeWidth="1" />
                            {noteTooltipLayout.lines.map((line: string, lineIndex: number) => (
                                <text key={`${spoke.id}-note-tooltip-${lineIndex}`} x={noteTooltipLayout.textX} y={noteTooltipLayout.lineCenterYs[lineIndex]} fill="#f4ead7" fontSize="11" fontFamily="inherit" textAnchor="middle" dominantBaseline="middle">
                                    {line}
                                </text>
                            ))}
                        </g>
                    ) : null}
                </g>
                );
            })}
        </>
    );
}
